import React from 'react';
import './OrderCardTitle.less';

export const OrderCardTitle = ({text}) => {
	return <span className="order-card-title">{text}</span>
}
